
import { put, takeLatest } from "redux-saga/effects";
import axiosCustom from "../../../common/components/apiConfig";
import { handleNotificationAlertTrySelect, handleNotificationAlertCatch } from '../../../common/method/handleNotificationAlert';



export const actionTypes = {
    portfolioRiskSystematic: "[portfolioRiskSystematic] Action",
    portfolioRiskSystematicLoading: "[portfolioRiskSystematicLoading] Action",
    portfolioRiskSystematicAsync: "[portfolioRiskSystematicAsync] Action",
};

const initialState = {
    data: {},
    loading: false,
};


export const reducer_portfolio_portfolioRisk_systematic = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.portfolioRiskSystematic:
            return {
                ...state,
                data: payload
            }
        case actionTypes.portfolioRiskSystematicLoading:
            return {
                ...state,
                loading: payload
            }
        default:
            return state
    }
}

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.portfolioRiskSystematicLoading, payload: true })

    let config = {
        url: "select_request",
    }

    let data = {
        table: "portfolio",
        method_type: "systematic_unsystematic_risk",
        data: payload.data ? payload.data : {}
    }


    try {

        let res = yield axiosCustom(config, data)
        let flag = handleNotificationAlertTrySelect(res);

        if (!flag) return
        yield put({ type: actionTypes.portfolioRiskSystematic, payload: res.data.response.data })
    } catch {
        handleNotificationAlertCatch()
    } finally {
        yield put({ type: actionTypes.portfolioRiskSystematicLoading, payload: false })

    }




}

export function* portfolioRiskSystematic() {
    yield takeLatest(actionTypes.portfolioRiskSystematicAsync, handleWorker)
}